<template>
  <ul :class="options.containerClass">
    <li>
      <a @click="prevPage()">
        {{ options.prevText }}
      </a>
    </li>
    <li
      v-for="(page, pageIndex) in pages"
      :key="pageIndex"
      :class="{ active: page.selected, disabled: page.disabled }"
    >
      <a v-if="page.disabled">{{ page.content }}</a>
      <a v-else @click="handlePageSelected(page.index)">{{ page.content }}</a>
    </li>
    <li>
      <a @click="nextPage()">
        {{ options.nextText }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['pageCount', 'clickHandler', 'selected'],
  computed: {
    pages: function() {
      let items = {}
      if (this.pageCount <= this.options.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected
          }
          items[index] = page
        }
      } else {
        let leftPart = this.options.pageRange / 2
        let rightPart = this.options.pageRange - leftPart

        if (this.selected < leftPart) {
          leftPart = this.selected
          rightPart = this.options.pageRange - leftPart
        } else if (
          this.selected >
          this.pageCount - this.options.pageRange / 2
        ) {
          rightPart = this.pageCount - this.selected
          leftPart = this.options.pageRange - rightPart
        }

        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected
          }

          if (
            index <= this.options.marginPages - 1 ||
            index >= this.pageCount - this.options.marginPages
          ) {
            items[index] = page
            continue
          }

          let breakView = {
            content: '...',
            disabled: true
          }

          if (
            this.selected - leftPart > this.options.marginPages &&
            items[this.options.marginPages] !== breakView
          ) {
            items[this.options.marginPages] = breakView
          }

          if (
            this.selected + rightPart <
              this.pageCount - this.options.marginPages - 1 &&
            items[this.pageCount - this.options.marginPages - 1] !== breakView
          ) {
            items[this.pageCount - this.options.marginPages - 1] = breakView
          }

          let overCount = this.selected + rightPart - this.pageCount + 1

          if (overCount > 0 && index === this.selected - leftPart - overCount) {
            items[index] = page
          }

          if (
            index >= this.selected - leftPart &&
            index <= this.selected + rightPart
          ) {
            items[index] = page
            continue
          }
        }
      }
      return items
    }
  },
  methods: {
    handlePageSelected(selected) {
      if (this.selected === selected) return
      this.clickHandler(selected + 1)
    },
    prevPage() {
      if (this.selected <= 0) return
      this.clickHandler(this.selected)
    },
    nextPage() {
      if (this.selected >= this.pageCount - 1) return
      this.clickHandler(this.selected + 2)
    }
  },
  data() {
    return {
      options: {
        pageRange: '5',
        marginPages: '3',
        prevText: '«',
        nextText: '»',
        containerClass: 'pagination'
      }
    }
  }
}
</script>
